import { trpc } from '@/shared/api';

/** 메일 링크의 토큰으로 이메일 인증을 확정하는 뮤테이션. */
export const useVerifyEmail = () => trpc.auth.verifyEmail.useMutation();
